import { Directive, input, Optional, signal } from '@angular/core';
import { connectState } from '@examdojo/angular/util';
import { toObservable } from '@angular/core/rxjs-interop';
import { combineLatest, map, of } from 'rxjs';
import { StemLabelStateManagerDirective } from './stem-label-state-manager.directive';
import { StemLabelIndexDirective } from './stem-label-index.directive';

@Directive({
  selector: '[dojoStemLabel]',
  standalone: true,
})
export class StemLabelDirective {
  constructor(
    @Optional() private readonly stemLabelStateManager: StemLabelStateManagerDirective | null,
    @Optional() private readonly stemLabelIndex: StemLabelIndexDirective | null,
  ) {}

  readonly label = input<string>();

  readonly labelMap$ = this.stemLabelStateManager?.labelMap$ ?? of(null);
  readonly index = this.stemLabelIndex?.index ?? signal(null);

  readonly directiveLabel$ = combineLatest([this.labelMap$, toObservable(this.index)]).pipe(
    map(([labelMap, index]) => (labelMap && index !== null ? labelMap.get(index) : null)),
  );

  readonly inputLabel$ = toObservable(this.label);

  readonly label$ = combineLatest([this.directiveLabel$, this.inputLabel$]).pipe(
    map(([directiveLabel, inputLabel]) => inputLabel ?? directiveLabel ?? ''),
  );

  readonly state = connectState({
    label: this.label$,
  });
}
